import React, { useState } from 'react';
import { UploadCloudIcon, HistoryIcon } from 'lucide-react';
import { LeadUploader } from './components/LeadUploader';
import { HistoryView } from './components/views/HistoryView';
import { cn } from './lib/utils';
type Tab = 'upload' | 'history';
export function App() {
  const [tab, setTab] = useState<Tab>('upload');
  return <div className="min-h-full w-full bg-gray-100" data-id="element-0" data-mp="3fb9jzcn93go5">
      {/* App header */}
      <header className="border-b border-gray-200 bg-white" data-id="element-1" data-mp="2rlynw8guiagc">
        <div className="mx-auto max-w-[1400px] px-4 sm:px-6" data-id="element-2" data-mp="2mm2luerpkt3f">
          <div className="flex flex-wrap items-center justify-between gap-3 py-4" data-id="element-3" data-mp="2mnngs5hxqe1t">
            <div className="flex items-center gap-3" data-id="element-4" data-mp="31c9uy3vtszrg">
              <img src="https://www.google.com/s2/favicons?domain=mymtgdepot.com&sz=256" alt="Mortgage Depot" className="h-11 w-11 rounded-lg border border-gray-200 object-contain" data-id="element-5" data-mp="2wka02pum4x1q" />
              <div data-id="element-6" data-mp="23utby4e102bb">
                <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-navy" data-id="element-7" data-mp="23t8g8bfz6dbv">
                  Mortgage Depot
                </p>
                <h1 className="text-lg font-bold leading-tight text-gray-900" data-id="element-8" data-mp="3mkrdnl64zhdb">
                  Custom Lead Uploader
                </h1>
              </div>
            </div>
            <p className="text-xs text-gray-500" data-id="element-9" data-mp="5yhgo69t1c8">
              mymtgdepot.com · Salesforce, Teli AI &amp; Five9
            </p>
          </div>

          {/* Tabs */}
          <nav className="-mb-px flex gap-6" aria-label="Views" data-id="element-10" data-mp="2zmwhmy3ufmc9">
            <TabButton active={tab === 'upload'} onClick={() => setTab('upload')} icon={UploadCloudIcon} label="Upload Leads" data-id="element-11" data-mp="33nq6put0v76q" />
            <TabButton active={tab === 'history'} onClick={() => setTab('history')} icon={HistoryIcon} label="Upload History" data-id="element-12" data-mp="3dlw727z6k59h" />
          </nav>
        </div>
      </header>

      <main className="mx-auto max-w-[1400px] px-4 py-6 sm:px-6 sm:py-8" data-id="element-13" data-mp="swqchiblnjxz">
        {tab === 'upload' ? <LeadUploader data-id="element-14" data-mp="34ncnvv5d5yq" /> : <HistoryView data-id="element-15" data-mp="38b7cycbvyf1" />}
      </main>
    </div>;
}
function TabButton({
  active,
  onClick,
  icon: Icon,
  label
}: {
  active: boolean;
  onClick: () => void;
  icon: React.ElementType;
  label: string;
}) {
  return <button type="button" onClick={onClick} className={cn('flex items-center gap-2 border-b-2 pb-3 pt-1 text-sm font-semibold transition-colors', active ? 'border-salesforce-500 text-salesforce-700' : 'border-transparent text-gray-500 hover:text-gray-800')} data-id="element-16" data-mp="85ujnspgu14c">
      <Icon className="h-4 w-4" data-id="element-17" data-mp="3qc95sexw1hdt" />
      {label}
    </button>;
}